import styled from 'styled-components'

export const Container = styled.div`
    width: 100%;
    margin: 0 auto;
`

export const Card = styled.div`
    background-color: #fefefe;
    width: 266px;
    height: 368px;
    border-radius: 24px;
    padding: 32px;
    margin-right: 15px;

    display: flex;
    flex-direction: column;
    justify-content: space-between;

    @media (min-width: ${({ theme }) => theme.breakpoints[0]}) {
        margin-right: 24px;
    }

    @media (min-width: ${({ theme }) => theme.breakpoints[1]}) {
        margin-right: 24px;
        height: 410px;
    }
`
export const Title = styled.div`
    text-align: center;
    margin-bottom: 32px;

    font-weight: 700;
    font-size: 16px;
    line-height: 150%;

    @media (min-width: ${({ theme }) => theme.breakpoints[0]}) {
    }
`

export const ContainerCard = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;

    img {
        position: absolute;
        top: 152px;
        z-index: 1;
    }
    @media (min-width: ${({ theme }) => theme.breakpoints[0]}) {
        img {
            top: 140px;
        }
    }

    @media (min-width: ${({ theme }) => theme.breakpoints[1]}) {
        img {
            top: -74px;
        }
    }
`

export const Exam = styled.div`
    font-size: 16px;
    font-weight: 700;
    text-transform: capitalize;
    line-height: 150%;
    max-width: 200px;
    margin-bottom: 22px;

    @media (min-width: ${({ theme }) => theme.breakpoints[1]}) {
        margin-bottom: 32px;
    }
`

export const ExamName = styled.div`
    font-size: 16px;
    font-weight: 700;
    line-height: 150%;
    max-width: 200px;
`

export const ExamList = styled.div`
    display: flex;
    flex-direction: column;
    justify-items: flex-start;
    height: 100%;
`

export const ExamPrice = styled.div`
    font-size: 14px;
    line-height: 24px;
    font-weight: 400;
    height: 24px;

    span {
        font-weight: 700;
        line-height: 16px;
    }
`
